import { captureError } from '@/sentry';

export type LeaderboardRun = {
  id: string;
  guild_id: string;
  leaderboard_type: string;
  score: number;
  discord_user_id: string;
  discord_name: string;
  submitted_at: string;
  metadata?: Record<string, unknown> | null;
};

export type SubmitLeaderboardInput = {
  guildId: string;
  leaderboardType: string;
  score: number;
  discordAccessToken: string;
  metadata?: Record<string, unknown>;
};

export async function submitLeaderboardRun(input: SubmitLeaderboardInput): Promise<{
  success: boolean;
  run?: LeaderboardRun;
  rank?: number;
} | null> {
  try {
    const response = await fetch('/api/leaderboard/submit', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(input),
    });

    if (!response.ok) return null;
    return (await response.json()) as { success: boolean; run?: LeaderboardRun; rank?: number };
  } catch (error) {
    captureError(error, { scope: 'leaderboard', action: 'submitLeaderboardRun' });
    return null;
  }
}

export async function fetchLeaderboard(params: {
  guildId: string;
  leaderboardType: string;
  limit?: number;
}): Promise<LeaderboardRun[] | null> {
  try {
    const url = new URL('/api/leaderboard', window.location.origin);
    url.searchParams.set('guildId', params.guildId);
    url.searchParams.set('leaderboardType', params.leaderboardType);
    if (params.limit) {
      url.searchParams.set('limit', String(params.limit));
    }

    const response = await fetch(url.toString(), { method: 'GET' });
    if (!response.ok) return null;

    const data = (await response.json()) as { runs?: LeaderboardRun[] };
    return Array.isArray(data?.runs) ? data.runs : null;
  } catch (error) {
    captureError(error, { scope: 'leaderboard', action: 'fetchLeaderboard' });
    return null;
  }
}
